import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import AmtplProduct from "./Product"; // Renamed to avoid naming conflict
import TransferofferCharges from "./TransferofferCharges";
import TransportShipping from "./TransportShipping";
import CountryWiseProduct from "./CountryWiseProduct";
import AmtplBank from "./Bank";

const AmtplProductModule = () => {
    const [activeTab, setActiveTab] = useState("Products");
    const tabs = ["Products", "Transport Offer Charges", "Transport & Shipping", "Country Wise Product","Banks"];

    const renderTabContent = () => {
        switch (activeTab) {
            case "Browse Products":
                return <AmtplProduct />;
            case "Transport Offer Charges":
                return <TransferofferCharges />;
            case "Transport & Shipping":
                return <TransportShipping />;
            case "Country Wise Product":
                return <CountryWiseProduct />;
            case "Banks":
                return <AmtplBank />;
            default:
                return <AmtplProduct />; // Added return statement
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab ? "active" : "notactive"}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AmtplProductModule;